import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import axios, { CancelToken } from "axios";
import dayjs from "dayjs";
import transactionsDataMapper from "utils/transactionsDataMapper";
import { DATE_QUERY_FORMAT } from "constants/dateFormats";
import { DASHBOARD } from "../../../../constants/api";

const makeRequest = async (source, range) => {
  const query = range
    ? {
        start_date: range.startDate.format(DATE_QUERY_FORMAT),
        end_date: range.endDate.format(DATE_QUERY_FORMAT),
      }
    : {
        start_date: dayjs().format(DATE_QUERY_FORMAT),
        end_date: dayjs().format(DATE_QUERY_FORMAT),
      };

  try {
    const response = await axios.get(DASHBOARD, {
      params: query,
      cancelToken: source.token, // this is just because the componet renders 2 times once we fix that issue we wont need this
    });

    return response;
  } catch (error) {
    return error;
  }
};

const depositsDataMapper = (data, formatDate) => {
  const rows = data.operations.map((item) => ({
    key: item.id,
    date: formatDate(item.date_request, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }),
    name: item.bank_account.alias,
    status: item.status,
    sellChannel: item.bank_account.bank_name,
    total: item.total.amount,
    currency: item.total.currency,
  }));

  return { rows };
};

const useDashboard = (range, username) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [transactions, setTransactions] = useState({});
  const [deposits, setDeposits] = useState({});
  const [dashboard, setDashborad] = useState({});
  const intl = useIntl();

  useEffect(() => {
    const source = CancelToken.source();

    const getData = async () => {
      setError(false);
      setLoading(true);

      const response = await makeRequest(source, range);

      if (response?.data?.success) {
        const data = response.data.result;

        setDashborad({
          transaction: data.operations.result.total,
          acceptanceRate: 0,
          totalProcessed: data.operations.result.sales,
        });

        setTransactions(
          transactionsDataMapper(
            data.operations.result,
            intl.formatDate,
            username
          )
        );

        setDeposits(
          depositsDataMapper(data.redrawalOrders.result, intl.formatTime)
        );

        setLoading(false);
      } else {
        setError(true);
        setLoading(false);
      }
    };

    getData();

    return () => {
      source.cancel("Component unmounted");
    };
  }, [range, intl.formatTime, intl.formatDate, username]);

  return { loading, error, transactions, deposits, dashboard };
};

export default useDashboard;
